export const COMPANY = {
  CREATE_COMPANY: "Create Company",
  EDIT_COMPANY: "Edit Company",
  DELETE_COMPANY: "Delete Company",
  DUPLICATE_COMPANY: "Duplicate Company",
  INCLUDE_COMPANY_DATA: "Include company related data",
  VIEW_AS_COMPANY: "View As Company",
};
